
import React from "react";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import './DataTable.css';

import { provideGlobalGridOptions } from 'ag-grid-community';

provideGlobalGridOptions({
    theme: "legacy"
})

const DataTable = ({ height, columns, rows, paginationProp, paginationPageSize, onPaginationChanged, paginationPageSizeSelector, rowSelection, isRowSelectable, suppressRowClickSelection, onRowSelected, gridOptions, onGridReady, onSelectionChanged, headerCheckboxSelectionFilterOnly, isCellCheckboxSelection, onFirstDataRendered, ref, selectionColumnDef, getRowStyle, getRowId, cellEditorParams, stopEditingWhenCellsLoseFocus, onCellValueChanged, onFilterChanged, postFilterChanged, suppressMenuHide, getRowHeight, defaultColDef, enableCharts, cellSelection, rowModelType, datasource, cacheBlockSize, immutableData }) => {
const isAutoHeight = gridOptions?.domLayout === "autoHeight";
const rowData = rowModelType === "infinite" ? undefined : rows;
    return (
        <div
            className="ag-theme-quartz"
            style={{
        height: isAutoHeight ? "auto" : height || 600,
        minHeight: isAutoHeight ? 300 : undefined,
        width: "100%",
      }}
        >
            <AgGridReact
                ref={ref}
                rowData={rowData}
                immutableData={immutableData || false}
                columnDefs={columns}
                pagination={paginationProp || false}
                rowModelType={rowModelType}
                datasource={datasource}
                cacheBlockSize={cacheBlockSize}
                // rowModelType={"serverSide"}
                paginationPageSize={paginationPageSize || 10}
                onPaginationChanged={onPaginationChanged}
                paginationPageSizeSelector={paginationPageSizeSelector || [10, 20, 30, 50, 100]}
                rowSelection={rowSelection || "multiple"}
                isRowSelectable={isRowSelectable}
                suppressRowClickSelection={suppressRowClickSelection || true}
                //getRowClass={(param)=>'ag-row-hover'}
                moveColumns={false}
                undoRedoCellEditing={true} // Enable undo/redo for cell editing
                suppressDragLeaveHidesColumns={true}
                suppressMovable={false}
                onRowSelected={onRowSelected}
                domLayout={gridOptions?.domLayout}
                gridOptions={gridOptions}
                onGridReady={onGridReady}
                onSelectionChanged={onSelectionChanged}
                headerCheckboxSelectionFilterOnly={headerCheckboxSelectionFilterOnly}
                isCellCheckboxSelection={isCellCheckboxSelection}
                onFirstDataRendered={onFirstDataRendered}
                selectionColumnDef={selectionColumnDef}
                getRowStyle={getRowStyle}
                getRowId={getRowId}
                cellEditorParams={cellEditorParams}
                stopEditingWhenCellsLoseFocus={stopEditingWhenCellsLoseFocus || true}
                onCellValueChanged={onCellValueChanged}
                onFilterChanged={onFilterChanged}
                postFilterChanged={postFilterChanged}
                suppressMenuHide={suppressMenuHide}
                // enableCellTextSelection={true} 
                getRowHeight={getRowHeight}
                suppressRowTransform={true}
                defaultColDef={defaultColDef}
                enableRangeSelection={true} // Enable range selection
                enableFillHandle={true} // Enable drag fill/copy
                enableCharts={enableCharts || false}
                cellSelection={cellSelection}
            />
        </div>
    )
}
export default DataTable

